import { defineStore } from 'pinia'
import getters from './getters'
import actions from './actions'

const namespaced = true

const state = () => ({
  startpage: [],
  featuredVideo: {},
  articleLists: {},
  articles: {},
  categories: [],
  materialCategories: [],
  materialLists: {},
  materials: {},
  tags: {}
})

export const pressStore = defineStore('press', {
  namespaced,
  state: () => state(),
  actions,
  getters
})

export default pressStore
